import { render, staticRenderFns } from "./quickview.vue?vue&type=template&id=536938c3&"
import script from "./quickview.vue?vue&type=script&lang=js&"
export * from "./quickview.vue?vue&type=script&lang=js&"
import style0 from "./quickview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536938c3')) {
      api.createRecord('536938c3', component.options)
    } else {
      api.reload('536938c3', component.options)
    }
    module.hot.accept("./quickview.vue?vue&type=template&id=536938c3&", function () {
      api.rerender('536938c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/quickview.vue"
export default component.exports